import script from "./PendingMatchCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PendingMatchCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__